import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {catchError, finalize, of, Subject, take, takeUntil} from 'rxjs';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {AceiteRecusaPortabilidadeEnum} from 'src/app/api/module/erp/shared/enumerable/aceite-recusa-portabilidade-enum';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {TipoDeclinioPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-declinio-proposta-enum';
import {TipoModalAssinaturaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-modal-assinatura';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {PerguntasDecalaracaoSaudeService} from 'src/app/api/module/externo/services/proposta/perguntas-declaracao-saude.service';
import {FormatarUtil} from 'src/app/pages/area-logada/shared/pipes/utils/formatadores.util';
import {FormularioDadosBancariosPropostaComponent} from '../../../../../shared/formulario-dados-bancarios-proposta/formulario-dados-bancarios-proposta.component';
import {ReducaoCarenciaPropostaComponent} from '../../../../../shared/reducao-carencia-proposta/reducao-carencia-proposta.component';

@Component({
  selector: 'app-proposta-documento-final-udemo',
  templateUrl: './proposta-documento-final-udemo.component.html',
  styleUrls: ['./proposta-documento-final-udemo.component.scss'],
})
export class PropostaDocumentoFinalUdemoComponent implements OnInit {
  @ViewChild(ReducaoCarenciaPropostaComponent)
  _reducaoCarenciaPropostaComponent!: ReducaoCarenciaPropostaComponent;
  @ViewChild(FormularioDadosBancariosPropostaComponent)
  _formularioDadosBancariosPropostaComponent!: FormularioDadosBancariosPropostaComponent;
  @Input() idProposta!: string;
  @Input() listaBeneficiarioDSSelecionados!: string[];
  @Input() dadosOperadoraDM!: any;

  readonly TipoPropostaEnum = TipoPropostaEnum;
  private destroy$ = new Subject<void>();
  tipoPropostaTitular!: TipoPropostaEnum;
  listaBeneficiariosFormulario: FormGroup[] = [];
  nomeTitular: string = '';
  cpfTitular: string = '';
  codigoProposta = '';
  entidadeProposta: string = '';
  tipoProduto = TipoProduto_E_OperadoraEnum.UDEMO_SAUDE;
  razaoSocialEntidade: string = '';
  vigenciaProposta: string = '';
  tipoPlano: string = '';
  acomadacaoPlano: string = '';
  ansProduto: string = '';
  beneficiarios = new Array<any>();
  totalPlano!: number;
  totalPlanoComTaxa!: number;
  respostasTitular: any[] = [];
  respostasDependentes: any[] = [];
  perguntasDeclaracaoSaude = new Array<any>();
  respostasPositivasDS = new Array<any>();
  dadosProstaCompletos: any;
  beneficiariosComDocumentos: any[] = [];
  mostrarQuadroDoisReducaoCarencia: boolean = false;
  listaBeneficiariosCarencias = new Array<any>();
  formularioReducaoCarencia!: FormGroup;
  horaAssinaturaReducaoCarencia: string = '';
  dataAssinaturaReducaoCarencia: string = '';
  assinaturasPorTipo: {[key: string]: {data: string; hora: string}} = {};
  dataAssinaturaOrientacaoPortabilidade: string = '';
  horaAssinaturaOrientacaoPortabilidade: string = '';
  mostrarOrientacaoPortabilidade: boolean = false;
  dataAssinaturaOrientacaoSumula: string = '';
  horaAssinaturaOrientacaoSumula: string = '';
  mostrarOrientacaoSumula: boolean = false;
  dataAssinaturaDadosBancarios: string = '';
  horaAssinaturaDadosBancarios: string = '';
  dataAssinaturaDS: string = '';
  horaAssinaturaDS: string = '';
  dataAssinaturaCartaOrientacaoDS: string = '';
  horaAssinaturaCartaOrientacaoDS: string = '';
  dataAssinaturaDocFinal: string = '';
  horaAssinaturaDocFinal: string = '';
  tipoRegistroProduto: string = '';
  dataDeclinio: string = '';
  horaDeclinio: string = '';
  motivoDeclinio: string = '';
  tipoDeclinio!: TipoDeclinioPropostaEnum;
  ehCampanha: boolean = false;
  mostrarDS: boolean = false;
  aceiteOuRecusaPortabilidade: AceiteRecusaPortabilidadeEnum = 1;
  dataAceiteRecusaPortabilidade: string = '12/10/2025';
  dataInicioVigenciaContrato: string = '22/10/2025';
  numeroCartao: string = '123456';
  dadosOperadoraCabecalho: any;
  operadoraVM: any;
  nomeCorretora: string = '';
  nomeVendedor: string = '';
  formEntidadeSomenteLeitura = true;
  existeFormularioEntidade: boolean = true;
  retornoDadosFormularioEntidade: any;
  valorRecebidoPeloBeneficiario: any;
  statusProposta: boolean = false;
  heMedSenior: boolean;
  dataCriacaoProposta: any;

  constructor(
    private formBuilder: FormBuilder,
    private _activeRoute: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private toastr: ToastrService,
    private _errorLoggingService: ErrorLoggingService,
    private _perguntasDecalaracaoSaudeService: PerguntasDecalaracaoSaudeService,
    private _entidadeService: EntidadeService,
    private _propostaCotacaoService: PropostaCotacaoService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.buscarPerguntas();
    await this.buscarDadosDocFinal();
    this.operadoraVM = this.carregarDadosOperadoraUDEMO();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  async buscarPerguntas(): Promise<void> {
    this._perguntasDecalaracaoSaudeService.perguntasDeclaracaoSaude().subscribe(data => {
      this.perguntasDeclaracaoSaude = data && data;
    });
  }

  async buscarDadosDocFinal(): Promise<void> {
    this.iniciarSpinner();
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || this.idProposta;
    this._propostaCotacaoService
      .buscarDadosDocumentoFinal(propostaId, this.listaBeneficiarioDSSelecionados)
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        catchError(error => {
          this.toastr.error('Falha ao carregar documento com dados completos da proposta');
          this._errorLoggingService.logError('Buscar dados da proposta para o documento final', error, {
            contexto: 'Erro ao buscar dados da proposta para o documento final',
            data: {
              idProoposta: this.idProposta,
              listaBeneficiarioDSSelecionados: this.listaBeneficiarioDSSelecionados,
            },
          });
          return of([]);
        }),
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe(data => {
        debugger;
        this.heMedSenior = data.operatorName.toLowerCase() === 'medsenior';
        let heUdemo = false;
        if (data?.branchCompanyName?.toLowerCase() === 'udemo') {
          heUdemo = true;
        }

        this.dadosOperadoraCabecalho = {
          nomeOperadora: data.operatorName,
          ansRegister: data.operatorAnsRegister,
          site: data.operatorSite,
          cnpjOperadora: data.operatorCNPJ,
          contatoOPeradora: data.operatorNumber,
          tipoProduto: data?.productType,
          logoOperadora: data?.operatorURLImage,
          ehInclusaoDependente: data?.dependentInclusion,
          tipo: TipoProduto_E_OperadoraEnum.UDEMO_SAUDE,
          dadosEntidade: {
            heUdemo: heUdemo,
            nomeEntidade: data?.branchCompanyName,
            logoEntidade: data.branchCompanyNameLogo,
          },
        };

        this.dadosProstaCompletos = data && data;
        let propostaDeclinada = data.active;
        this.nomeCorretora = this.dadosProstaCompletos?.brokerDescription;
        this.nomeVendedor = this.dadosProstaCompletos?.brokerEmployeeDescription;
        this.valorRecebidoPeloBeneficiario = data.valueReceived;
        this.dataCriacaoProposta = this.dadosProstaCompletos?.createDate;

        this.executarMetodosSequenciasComSeguranca(this.separarBeneficiarios, this.dadosProstaCompletos);
        this.executarMetodosSequenciasComSeguranca(this.preencherDadosDaProposta);
        this.executarMetodosSequenciasComSeguranca(this.preencherAssinaturas, this.dadosProstaCompletos.dealLeads);
        this.executarMetodosSequenciasComSeguranca(this.preencherDadosBancarios);
        if (!this.heMedSenior) {
          this.executarMetodosSequenciasComSeguranca(this.organizarRespostasDS);
        }
        this.buscarDadosPropostaEntidadeFormulario();
        if (!propostaDeclinada) {
          this.mostrarDeclinioProposta(this.dadosProstaCompletos);
        }
        this.montarBeneficiariosComDocumentos();
      });
  }

  private executarMetodosSequenciasComSeguranca(fn: Function, ...args: any[]) {
    try {
      fn.apply(this, args);
    } catch (e: any) {}
  }
  criarFormGrupoBeneficiario(dados: any): FormGroup {
    return this.formBuilder.group({
      name: new FormControl(dados.name || ''),
      birthDate: new FormControl(FormatarUtil.data(dados.birthDate || '')),
      cpf: new FormControl(FormatarUtil.cpf(dados.cpf || null)),
      civilStatus: new FormControl(dados?.civilStatus?.name || ''),
      sex: new FormControl(FormatarUtil.sexo(dados.sex || '')),
      cns: new FormControl(FormatarUtil.cns(dados.cns || '')),
      mothersName: new FormControl(dados.mothersName || ''),
      adress: new FormControl(dados.addressData?.adress || ''),
      neighborhood: new FormControl(dados.addressData?.adressNeighborhood || ''),
      number: new FormControl(dados.addressData?.adressNumber || ''),
      state: new FormControl(dados.addressData?.city.state.uf || ''),
      city: new FormControl(dados.addressData?.city.name || ''),
      cep: new FormControl(FormatarUtil.cep(dados.addressData?.adressCep || '')),
      adressComplement: new FormControl(dados.addressData?.adressComplement || ''),
      previousOperator: new FormControl(dados.analysisPeriodReduction?.previousOperator || ''),
      dwellTime: new FormControl(dados.analysisPeriodReduction?.dwellTime || ''),
      mobilePhone: new FormControl(FormatarUtil.telefone(dados.mobilePhone || '')),
      homePhone: new FormControl(FormatarUtil.telefone(dados.homePhone || '')),
      businessPhone: new FormControl(FormatarUtil.telefone(dados.businessPhone || '')),
      email: new FormControl(dados.email || ''),
      branchCompanyContractKinship: new FormControl(dados?.branchCompanyContractKinship?.description || ''),
      // Campos que não recebem dados do Banco
      declaracaoNascidoVivo: new FormControl(dados.declaracaoNascidoVivo || ''),
      rg: new FormControl(dados.rg || ''),
      shipmentDate: new FormControl(dados.shipmentDate || ''),
      idIssuingBody: new FormControl(dados.idIssuingBody || ''),
      dataAdmissao: new FormControl(dados.dataAdmissao || ''),
      pis: new FormControl(dados.pis || ''),
      localAtendimento: new FormControl(dados.localAtendimento || ''),
    });
  }

  formatarResposta(resposta: any): string {
    if (!resposta) return 'N';

    // Para perguntas de altura (27) e peso (28)
    if (resposta.codeQuestion === 27 && resposta.height) {
      return `${(resposta.height / 100).toFixed(2)}`; // Converter cm para metros
    }

    if (resposta.codeQuestion === 28 && resposta.weight) {
      return `${resposta.weight}`;
    }

    return resposta.response ? 'S' : 'N';
  }

  private separarBeneficiarios(dados: any) {
    const beneficiario = dados?.holderProposal;
    if (!beneficiario) return;
    const {dependentsProposal = [], ...titularData} = beneficiario;

    // Titular
    this.beneficiariosComDocumentos.push({
      nome: titularData.name,
      documentos: titularData.documentProposals || [],
    });

    // Dependentes
    dependentsProposal.forEach((dependente: any) => {
      this.beneficiariosComDocumentos.push({
        nome: dependente.name,
        documentos: dependente.documentProposals || [],
      });
    });
    this.adicionarBeneficiario({...titularData, isDependent: false});
    this.processarDependentes(dependentsProposal);
    this.preencherReducacaoCarencia(titularData);
  }

  private adicionarBeneficiario(dados: any) {
    // Lista de objetos simples
    this.beneficiarios.push(dados);

    // Lista de FormGroups
    const formGroup = this.criarFormGrupoBeneficiario(dados);
    this.listaBeneficiariosFormulario.push(formGroup);
  }

  private processarDependentes(dependents: any[]) {
    if (!Array.isArray(dependents)) return;

    dependents.forEach(dependente => {
      this.adicionarBeneficiario({
        ...dependente,
        isDependent: true,
      });
    });
  }

  processarRespostasBeneficiario(respostas: any[], tipoBeneficiario: string) {
    respostas.forEach((resposta: any) => {
      if (resposta.response && resposta.codeQuestion <= 26) {
        // Processar evento 1
        if (resposta.descriptionEvent1 && resposta.displayDs1) {
          this.respostasPositivasDS.push({
            tipoBeneficiario: tipoBeneficiario,
            item: resposta.codeQuestion,
            dataEvento: resposta.eventDateDescription1,
            especificacoes: resposta.descriptionEvent1,
            cid: FormatarUtil.cid(resposta.cid1),
          });
        }

        // Processar evento 2
        if (resposta.descriptionEvent2 && resposta.displayDs2) {
          this.respostasPositivasDS.push({
            tipoBeneficiario: tipoBeneficiario,
            item: resposta.codeQuestion,
            dataEvento: resposta.eventDateDescription2,
            especificacoes: resposta.descriptionEvent2,
            cid: FormatarUtil.cid(resposta.cid2),
          });
        }

        // Processar evento 3
        if (resposta.descriptionEvent3 && resposta.displayDs3) {
          this.respostasPositivasDS.push({
            tipoBeneficiario: tipoBeneficiario,
            item: resposta.codeQuestion,
            dataEvento: resposta.eventDateDescription3,
            especificacoes: resposta.descriptionEvent3,
            cid: FormatarUtil.cid(resposta.cid3),
          });
        }

        // Processar evento 4
        if (resposta.descriptionEvent4 && resposta.displayDs4) {
          this.respostasPositivasDS.push({
            tipoBeneficiario: tipoBeneficiario,
            item: resposta.codeQuestion,
            dataEvento: resposta.eventDateDescription4,
            especificacoes: resposta.descriptionEvent4,
            cid: FormatarUtil.cid(resposta.cid4),
          });
        }
      }
    });
  }

  organizarRespostasDS() {
    // Processar respostas do titular
    if (this.dadosProstaCompletos?.holderProposal?.healthQuestionProposal) {
      this.respostasTitular = this.dadosProstaCompletos.holderProposal.healthQuestionProposal;
    } else {
      this.respostasTitular = [];
    }

    // Processar respostas dos dependentes
    this.respostasDependentes = [];

    if (this.dadosProstaCompletos?.holderProposal?.dependentsProposal) {
      this.dadosProstaCompletos.holderProposal.dependentsProposal.forEach((dependente: any, index: number) => {
        if (dependente.healthQuestionProposal) {
          this.respostasDependentes[index] = dependente.healthQuestionProposal;
        } else {
          this.respostasDependentes[index] = [];
        }
      });
    }

    const temRespostasTitular = this.temRespostasTitular();
    const temRespostasDependentes = this.getDependentesComRespostas().length > 0;

    this.mostrarDS = temRespostasTitular || temRespostasDependentes;

    this.preencherRespostasPositivasDS();
  }

  getRespostasTermoDS(beneficiario: any): string {
    if (!beneficiario.healthQuestionProposal) return '3';

    const pergunta99 = beneficiario.healthQuestionProposal.find((q: any) => q.codeQuestion === 99);

    return pergunta99?.optionForPreExistingIllnesses || '3';
  }

  getAgrupamentoBeneficiarioPorDS(): {nomes: string[]; valor: string}[] {
    const respostas: {nome: string; valor: string}[] = [];

    // Processar titular - só adiciona se tiver respostas
    if (this.dadosProstaCompletos?.holderProposal && this.respostasTitular && this.respostasTitular.length > 0) {
      const valorTitular = this.getRespostasTermoDS(this.dadosProstaCompletos.holderProposal);
      respostas.push({
        nome: this.dadosProstaCompletos.holderProposal.name,
        valor: valorTitular,
      });
    }

    // Processar dependentes - só adiciona se tiver respostas
    if (this.dadosProstaCompletos?.holderProposal?.dependentsProposal) {
      this.dadosProstaCompletos.holderProposal.dependentsProposal.forEach((dependente: any, index: number) => {
        // Verifica se o dependente tem respostas
        if (this.respostasDependentes[index] && this.respostasDependentes[index].length > 0) {
          const valorDependente = this.getRespostasTermoDS(dependente);
          respostas.push({
            nome: dependente.name,
            valor: valorDependente,
          });
        }
      });
    }

    // Agrupar por valor da resposta
    const agrupado: {[valor: string]: string[]} = {};

    respostas.forEach(r => {
      if (!agrupado[r.valor]) agrupado[r.valor] = [];
      agrupado[r.valor].push(r.nome);
    });

    return Object.keys(agrupado).map(valor => ({
      valor,
      nomes: agrupado[valor],
    }));
  }

  preencherDadosDaProposta() {
    this.entidadeProposta = this.dadosProstaCompletos.branchCompanyName;
    this.razaoSocialEntidade = this.dadosProstaCompletos.branchCompanySocialReason;
    this.codigoProposta = String(this.dadosProstaCompletos.code);
    this.vigenciaProposta = FormatarUtil.data(this.dadosProstaCompletos.effectiveDate);
    this.tipoPlano = this.dadosProstaCompletos.productName;
    this.acomadacaoPlano = this.dadosProstaCompletos.accommodationName;
    this.totalPlano = this.dadosProstaCompletos.totalPriceValue;
    this.totalPlanoComTaxa = this.dadosProstaCompletos.membershipFee;
    this.nomeTitular = this.dadosProstaCompletos.holderProposal.name;
    this.cpfTitular = FormatarUtil.cpf(this.dadosProstaCompletos.holderProposal.cpf);
    this.ansProduto = this.dadosProstaCompletos.registerNumber;
    this.tipoPropostaTitular = this.dadosProstaCompletos.proposalType;
    this.tipoRegistroProduto = this.dadosProstaCompletos.registerType;
  }
  getHoraAssinatura(beneficiario: any): string {
    return FormatarUtil.getHoraAssinatura(beneficiario);
  }

  getDataHoraAssinatura(beneficiario: any, tipoModal: string): {data: string; hora: string} {
    return FormatarUtil.getDataHoraAssinatura(beneficiario, tipoModal);
  }
  preencherAssinaturas(dados: any) {
    let listaStepsAssinados = dados;
    let assinaturaDadosBancarios;

    const assinaturasDocFinal = listaStepsAssinados.find(
      (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_ENDERECO,
    );
    if (this.dadosOperadoraCabecalho.ehInclusaoDependente) {
      assinaturaDadosBancarios = listaStepsAssinados.find(
        (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_ENDERECO,
      );
    } else {
      assinaturaDadosBancarios = listaStepsAssinados.find(
        (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_BANCO,
      );
    }
    const assinaturaCartaOrientacaoDS = listaStepsAssinados.find(
      (item: any) => item.step === PropostaExternaEnum.CARTA_ORIENTACAO,
    );
    const assinaturaDS = listaStepsAssinados.find((item: any) => item.step === PropostaExternaEnum.VIDEO_CONFERENCIA);

    if (assinaturasDocFinal) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturasDocFinal.createDate);
      this.dataAssinaturaDocFinal = dataAssinatura.data;
      this.horaAssinaturaDocFinal = dataAssinatura.hora;
    }

    if (assinaturaDadosBancarios) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturaDadosBancarios.createDate);
      this.dataAssinaturaDadosBancarios = dataAssinatura.data;
      this.horaAssinaturaDadosBancarios = dataAssinatura.hora;
    }

    if (assinaturaCartaOrientacaoDS) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturaCartaOrientacaoDS.createDate);
      this.dataAssinaturaCartaOrientacaoDS = dataAssinatura.data;
      this.horaAssinaturaCartaOrientacaoDS = dataAssinatura.hora;
    }

    if (assinaturaDS) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturaDS.createDate);
      this.dataAssinaturaDS = dataAssinatura.data;
      this.horaAssinaturaDS = dataAssinatura.hora;
    }
  }

  preencherDadosBancarios() {
    const dadosBancarios = this.dadosProstaCompletos?.holderProposal?.bankDetails;
    if (dadosBancarios) {
      this._formularioDadosBancariosPropostaComponent.preencherDados(dadosBancarios);
    }
  }

  preencherRespostasPositivasDS() {
    this.respostasPositivasDS = [];

    this.processarRespostasBeneficiario(this.respostasTitular, 'Tit.');

    this.respostasDependentes.forEach((respostasDependente: any[], index: number) => {
      if (respostasDependente) {
        this.processarRespostasBeneficiario(respostasDependente, `Dep. ${index + 1}`);
      }
    });
  }

  preencherReducacaoCarencia(dadosTitular: any) {
    let respostaReducaoCarencia;
    this.beneficiarios.some((beneficiario: any) => {
      respostaReducaoCarencia = beneficiario?.analysisPeriodReductionCheck ? true : false;
    });
    this._reducaoCarenciaPropostaComponent?.preencherFormularioReducacaoCarencia(this.beneficiarios);

    this.mostrarQuadroDoisReducaoCarencia = respostaReducaoCarencia ? true : false;

    if (this.mostrarQuadroDoisReducaoCarencia) {
      this.preencherReducaoCarenciaQuadroDois();
    }

    let assinatura = this.dadosProstaCompletos?.dealLeads?.find(
      (item: any) => item?.step === PropostaExternaEnum?.BENEFICIARIO_ENDERECO,
    );
    let data = FormatarUtil.assinatura(assinatura?.createDate);
    this.dataAssinaturaReducaoCarencia = data.data;
    this.horaAssinaturaReducaoCarencia = data.hora;
  }

  preencherReducaoCarenciaQuadroDois() {
    this.listaBeneficiariosCarencias = [];

    this.beneficiarios?.forEach((beneficiario: any) => {
      // Verificar se o beneficiário tem redução de carências
      if (beneficiario.analysisPeriodReductionCheck) {
        const reducaoCarencia = beneficiario?.analysisPeriodReduction;

        const dataNascimento = new Date(beneficiario?.birthDate);
        const dataNascimentoFormatada = dataNascimento.toLocaleDateString('pt-BR');

        const dataUltimoPagamento = 'Não informado'; //verificar como vai pegar essa informaçao

        // Adicionar à lista de beneficiários com carências
        this.listaBeneficiariosCarencias.push({
          tipoBeneficiario: beneficiario?.isDependent ? 'Dependente' : 'Titular',
          name: beneficiario?.name,
          dataNascimento: dataNascimentoFormatada,
          operadora: reducaoCarencia?.previousOperator || 'Não informado',
          tempoPermanencia: reducaoCarencia?.dwellTime ? `${reducaoCarencia?.dwellTime}` : 'Não informado', //verificar regra para preenchimento da tabela do quador 1
          dataUltimoPagamento: dataUltimoPagamento,
        });
      }
    });

    this._reducaoCarenciaPropostaComponent?.preencherFormularioReducaoCarenciaQuadroDois(
      this.dadosProstaCompletos?.modalityProduct,
    );
  }

  private montarBeneficiariosComDocumentos() {
    this.beneficiariosComDocumentos = [];

    const titular = this.dadosProstaCompletos?.holderProposal;
    if (titular) {
      const docsTitular: any[] = [];

      // Redução de carência
      if (titular.analysisPeriodReduction) {
        const reducao = titular.analysisPeriodReduction;
        if (reducao.ctp) {
          docsTitular.push({
            description: 'Carta de Tempo de Permanência',
            filePath: reducao.ctp,
          });
        }
        if (reducao.dapo) {
          docsTitular.push({
            description: 'Documento de Adimplância do Plano de Origem',
            filePath: reducao.dapo,
          });
        }
      }

      // Documentos normais
      if (Array.isArray(titular.documentProposals)) {
        docsTitular.push(...titular.documentProposals);
      }

      this.beneficiariosComDocumentos.push({
        nome: titular.name || 'Titular',
        documentos: docsTitular,
      });
    }

    const dependentes = this.dadosProstaCompletos?.holderProposal?.dependentsProposal || [];
    dependentes.forEach((dep: any, index: number) => {
      const docsDep: any[] = [];

      // Redução de carência
      if (dep.analysisPeriodReduction) {
        const reducao = dep.analysisPeriodReduction;
        if (reducao.ctp) {
          docsDep.push({
            description: 'Carta de Tempo de Permanência',
            filePath: reducao.ctp,
          });
        }
        if (reducao.dapo) {
          docsDep.push({
            description: 'Documento de Adimplância do Plano de Origem',
            filePath: reducao.dapo,
          });
        }
      }

      // Documentos normais
      if (Array.isArray(dep.documentProposals)) {
        docsDep.push(...dep.documentProposals);
      }

      this.beneficiariosComDocumentos.push({
        nome: dep.name || `Dependente ${index + 1}`,
        documentos: docsDep,
      });
    });
  }

  private processarAssinaturasOrientacaoBeneficiario(beneficiario: any) {
    if (!beneficiario?.additiveSignatures) return;

    beneficiario.additiveSignatures.forEach((assinatura: any) => {
      const dataAssinaturaObj = new Date(assinatura.dateSignature);
      const dataFormatada = FormatarUtil.data(assinatura.dateSignature);
      const horaFormatada = dataAssinaturaObj.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      if (assinatura.modalType === TipoModalAssinaturaEnum.ORIENTACAO) {
        switch (assinatura.proposalType) {
          case TipoPropostaEnum.SUMULA:
            this.dataAssinaturaOrientacaoSumula = dataFormatada;
            this.horaAssinaturaOrientacaoSumula = horaFormatada;
            this.mostrarOrientacaoSumula = true;
            break;
          case TipoPropostaEnum.PORTABILIDADE:
            this.dataAssinaturaOrientacaoPortabilidade = dataFormatada;
            this.horaAssinaturaOrientacaoPortabilidade = horaFormatada;
            this.mostrarOrientacaoPortabilidade = true;
            break;
          default:
        }
      }
    });
  }

  private processarAssinaturasAditivosBeneficiario(beneficiario: any) {
    if (!beneficiario?.additiveSignatures) return;

    beneficiario.assinaturasPorTipo = {};

    beneficiario.additiveSignatures.forEach((assinatura: any) => {
      const dataAssinaturaObj = new Date(assinatura.dateSignature);
      const dataFormatada = FormatarUtil.data(assinatura.dateSignature);
      const horaFormatada = dataAssinaturaObj.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      if (assinatura.modalType === TipoModalAssinaturaEnum.ADITIVO) {
        let tipoModal = '';
        switch (assinatura.proposalType) {
          case TipoPropostaEnum.SUMULA:
            tipoModal = 'SUMULA';
            break;
          case TipoPropostaEnum.PORTABILIDADE:
            tipoModal = 'PORTABILIDADE';
            break;
          default:
            tipoModal = `TIPO_${assinatura.proposalType}`;
        }

        beneficiario.assinaturasPorTipo[tipoModal] = {
          data: dataFormatada,
          hora: horaFormatada,
        };
      }
    });
  }

  getBeneficiariosComSumula21EPortabolidade(): any[] {
    const beneficiariosFiltrados = this.beneficiarios.filter((proposta: any) => {
      return (
        proposta.proposalType === TipoPropostaEnum.SUMULA || proposta.proposalType === TipoPropostaEnum.PORTABILIDADE
      );
    });

    beneficiariosFiltrados.forEach(beneficiario => {
      this.processarAssinaturasAditivosBeneficiario(beneficiario);
      this.processarAssinaturasOrientacaoBeneficiario(beneficiario);
    });

    return beneficiariosFiltrados;
  }

  mostrarDeclinioProposta(dados: any) {
    const listaStepsAssinados = dados.dealLeads;
    const propostaDeclinada = listaStepsAssinados?.find(
      (item: any) => item.step === PropostaExternaEnum.PROPOSTA_DECLINADA,
    ); //Proposta Declinada
    this.motivoDeclinio = dados.declineReason;
    this.statusProposta = !!propostaDeclinada;

    if (this.motivoDeclinio) {
      let dataFormatada = FormatarUtil.assinatura(propostaDeclinada?.createDate);
      this.dataDeclinio = dataFormatada.data;
      this.horaDeclinio = dataFormatada.hora;
      this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_MOTIVO;
    } else {
      let dataFormatada = FormatarUtil.assinatura(propostaDeclinada?.createDate);
      this.dataDeclinio = dataFormatada.data;
      this.horaDeclinio = dataFormatada.hora;

      if (propostaDeclinada && this.tipoPropostaTitular == TipoPropostaEnum.PORTABILIDADE) {
        this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_PORTABILIDADE;
      } else {
        this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_25_DIAS;
      }
    }
  }

  getResposta(perguntaIndex: number, beneficiarioIndex: number): string {
    // Para o titular (índice 0)
    if (beneficiarioIndex === 0) {
      if (!this.temRespostasTitular()) {
        return 'N';
      }

      const resposta = this.respostasTitular.find((r: any) => r.codeQuestion === perguntaIndex);
      return this.formatarResposta(resposta);
    }

    // Para dependentes
    const dependenteIndex = beneficiarioIndex - 1;

    // Verifica se o dependente tem respostas
    if (!this.respostasDependentes[dependenteIndex] || this.respostasDependentes[dependenteIndex].length === 0) {
      return 'N';
    }

    const resposta = this.respostasDependentes[dependenteIndex].find((r: any) => r.codeQuestion === perguntaIndex);
    return this.formatarResposta(resposta);
  }

  getDependentesComRespostas(): any[] {
    const dependentesComRespostas: any = [];

    if (!this.dadosProstaCompletos?.holderProposal?.dependentsProposal) {
      return dependentesComRespostas;
    }

    // Verifica cada dependente para ver se tem respostas
    for (let i = 0; i < this.dadosProstaCompletos.holderProposal.dependentsProposal.length; i++) {
      const dependente = this.dadosProstaCompletos.holderProposal.dependentsProposal[i];

      // Verifica se o dependente tem respostas no array respostasDependentes
      if (this.respostasDependentes[i] && this.respostasDependentes[i].length > 0) {
        // Verifica se há pelo menos uma resposta não vazia
        const temRespostasValidas = this.respostasDependentes[i].some(
          (resposta: any) => resposta !== null && resposta !== undefined,
        );

        if (temRespostasValidas) {
          dependentesComRespostas.push({
            index: i,
            numero: i + 1,
            name: dependente.name || `Dep. ${i + 1}`,
          });
        }
      }
    }

    return dependentesComRespostas;
  }

  // Verifica se o titular tem respostas
  temRespostasTitular(): boolean {
    return (
      this.respostasTitular &&
      this.respostasTitular.length > 0 &&
      this.respostasTitular.some((r: any) => r !== null && r !== undefined)
    );
  }

  // Verifica se há respostas para mostrar a tabela
  mostrarTabelaDS(): boolean {
    return this.mostrarDS && (this.temRespostasTitular() || this.getDependentesComRespostas().length > 0);
  }

  carregarDadosOperadoraUDEMO(): string {
    const cnpjOperadoraFiltro =
      this.dadosOperadoraCabecalho?.cnpjOperadora || this.dadosOperadoraDM.operatorObject.cnpj;

    if (!cnpjOperadoraFiltro) {
      return '';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);
    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }

  async buscarDadosPropostaEntidadeFormularioAdservip() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;
    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAdservip(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.retornoDadosFormularioEntidade = data;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.existeFormularioEntidade = false;
          }
          // this.toastr.info(error.message);
          this.pararSpinner();
        },
      });
  }

  async buscarDadosPropostaEntidadeFormularioAbje() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;
    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAbje(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.retornoDadosFormularioEntidade = data;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.existeFormularioEntidade = false;
          }
          // this.toastr.info(error.message);
          this.pararSpinner();
        },
      });
  }

  async buscarDadosPropostaEntidadeFormulario() {
    if (this.entidadeProposta === 'ADSERVIP') {
      this.buscarDadosPropostaEntidadeFormularioAdservip();
    } else if (this.entidadeProposta === 'ABJE') {
      this.buscarDadosPropostaEntidadeFormularioAbje();
    }
  }

  //mês 9 (reajuste udemo que será aplicado em outubro) mostra aditivo
  ehReajusteUdemo(dataCriacaoProposta: any): boolean {
    return new Date(dataCriacaoProposta).getMonth() + 1 == 9 && this.entidadeProposta == 'UDEMO' ? true : false;
  }
}
